let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("20N8v")).then(() => parcelRequire('aVpt4'));